import { Actions } from './Modal.styles.js';
import { type HTMLAttributes } from 'react';

type ModalActionsProps = HTMLAttributes<HTMLParagraphElement> & {
  // fullWidth will override justifyContent with stretch
  readonly fullWidth?: boolean;
  readonly justifyContent?: 'center' | 'flex-end' | 'space-between';
};

const ModalActions = ({
  children,
  fullWidth,
  justifyContent,
}: ModalActionsProps) => {
  return (
    <Actions
      fullWidth={fullWidth}
      justifyContent={justifyContent}
    >
      {children}
    </Actions>
  );
};

ModalActions.displayName = 'Modal.Actions';

export { ModalActions };
